import { AssessmentTemplate } from '@app/src/types/resourceExplorer'
import React, { createContext, useContext } from 'react'
import { FilterGroup } from '../../ResourceCollection/Filters/useFilters'

export enum ProgressTrackerFilterType {
  Assessed = 'assessed',
  NotAssessed = 'notAssessed',
  SelfReported = 'selfReported',
  AiScreened = 'aiScreened',
  InScope = 'inScope',
  AssessmentLevel = 'assessmentLevel',
}

export type ProgressTrackerAssessmentDialogData = {
  assessmentTemplate: AssessmentTemplate
  activeLevel?: number
  periods: string[]
  filters: FilterGroup[]
  title: string
}

export type ProgressTrackerModalContextProps = {
  openProgressTrackerModal: (
    filterType: ProgressTrackerFilterType,
    assessmentTemplate: AssessmentTemplate,
    periodNames: string[],
    level?: number,
    title?: string,
  ) => void
  assessmentDialogData?: ProgressTrackerAssessmentDialogData
  setAssessmentDialogData: React.Dispatch<React.SetStateAction<ProgressTrackerAssessmentDialogData | undefined>>
}

export const ProgressTrackerModalContext = createContext<ProgressTrackerModalContextProps>({
  openProgressTrackerModal: () => undefined,
  setAssessmentDialogData: () => undefined,
})

export const useProgressTrackerModal = (): ProgressTrackerModalContextProps => {
  return useContext(ProgressTrackerModalContext)
}
